import React, { FunctionComponent } from "react";
import IconProps from "../IconProps.interface";

import { ReactComponent as File } from "assets/button-arrow-right.svg";

const Icon: FunctionComponent<IconProps> = (props): JSX.Element => {
    return (
        <File className={props.className} />
    );
};

export default Icon;